import { createHelpers } from 'vuex-map-fields';

import { CONTENT_SHEET_TOOGLE, CONTENT_SHEET_CONTENT } from '../actions/contentSheet';

const { getContentSheetField, updateContentSheetField } = createHelpers({
  getterType: 'getContentSheetField',
  mutationType: 'updateContentSheetField',
});

const state = {
  contentSheetIsOpen: false,
  contentSheetId: null,
  contentSheetData: null,
};

const getters = {
  getContentSheetField,
};

const mutations = {
  updateContentSheetField,

  [CONTENT_SHEET_TOOGLE]: (state) => {
    state.contentSheetIsOpen = !state.contentSheetIsOpen;
  },

  [CONTENT_SHEET_CONTENT]: (state, response) => {
    state.contentSheetId = response.sheetId;
    state.contentSheetData = response.data;
    state.contentSheetIsOpen = true;
  },
};

const actions = {
  [CONTENT_SHEET_TOOGLE]: ({ commit }) => {
    commit(CONTENT_SHEET_TOOGLE);
  },

  [CONTENT_SHEET_CONTENT]: ({ commit }, response) => {
    commit(CONTENT_SHEET_CONTENT, response);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
